import Head from 'next/head';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

import SearchPage from '@/contents/CampSite/search/SearchPage';
import constMeta from '@/contents/constants/constMeta';
import { GlobalContext } from '@/contents/hooks/state';
import Layout from '@/layouts';
import type { NextPageWithLayout } from '@/types';
import { Page } from '@/types/domain';

const NotEntered: NextPageWithLayout = () => {
  const router = useRouter();
  const { setPage, setSearchTotal } = useContext(GlobalContext);

  useEffect(() => {
    setPage(Page.SEARCH);
  }, [router]);

  useEffect(() => {
    return () => setSearchTotal(null);
  }, []);

  return (
    <>
      <Head>
        <title>{constMeta.searchNotEntered.title}</title>
        <meta
          name="description"
          content={constMeta.searchNotEntered.mata_description}
        />
        <meta property="og:url" content="https://iihi.life/search/notentered" />
        <meta property="og:title" content={constMeta.searchNotEntered.title} />
        <meta
          property="og:description"
          content={constMeta.searchNotEntered.mata_description}
        />
        <meta
          property="og:image"
          content="https://iihi.life/assets/images/common/ogp.jpg"
        />
      </Head>
      <SearchPage notEntered />
    </>
  );
};

NotEntered.getLayout = (page) => <Layout>{page}</Layout>;

export default NotEntered;
